module.exports = __webpack_public_path__ + "img/proj2.96e5a11d.png";